const monitoringTutorial = {
  module: 'monitoring',
  moduleName: 'Monitoring',
  steps: [
    {
      target: '.md-agent-banner',
      position: 'bottom',
      title: 'Agent Status',
      description: 'Shows if your network monitoring agent is connected and healthy.',
    },
    {
      target: '.page-header-actions .btn-primary',
      position: 'bottom',
      title: 'Run a Scan',
      description: 'Click to discover new devices on your network.',
    },
    {
      target: '.md-page',
      position: 'top',
      title: 'Dashboard Overview',
      description: 'Real-time device health, alerts, and network metrics all in one place.',
    },
  ],
};

export default monitoringTutorial;
